// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The mission type
 */
export type EmissionType = 'Ducted' | 'Diffuse';

export const EmissionType = {
    Ducted: 'Ducted' as EmissionType,
    Diffuse: 'Diffuse' as EmissionType
};

